<p-table class="history-list Auto_History_List"
         [value]="rowsToDisplay"
         [scrollable]="true" [totalRecords]="historyData?.length" [scrollHeight]="'20rem'"
         [rows]="maxNumberOfDisplayedRows"
         (onLazyLoad)="loadNext($event)">
    <ng-template pTemplate="body" let-rowData>
        <tr class="{{getRowClasses(rowData)}}" (click)="rowClick(rowData)">
            <td *ngFor="let column of columnsToDisplay" class="{{column.type}} property testType">
                <gen-history-table-item [historyRow]="rowData?.revision" [historyColumn]="column"></gen-history-table-item>
            </td>
        </tr>
    </ng-template>
</p-table>
